var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookieimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360.842,
    height: 318.607,
    viewBox: "0 0 360.842 318.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.786,
    y1: 0.736,
    x2: 0.786,
    y2: -0.071,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.677,
    y1: -0.283,
    x2: 2.677,
    y2: -1.243,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3433",
    "data-name": "Grupo 3433",
    transform: "translate(-0.038 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9900",
    "data-name": "Caminho 9900",
    d: "M96.71,179.657c1.075,12.1,7.933,23.048,12.119,34.568a81.944,81.944,0,0,1,1.595,50.883c-1,3.433-2.225,6.876-2.225,10.392,0,12.119,13.807,20.164,26.352,25.513a480.394,480.394,0,0,0,99.194,29.971c11.133,2.1,25.04,3.01,32.085-4.9,3.383-3.8,4.2-8.758,6.683-13.018,6.332-10.861,21.74-15.086,35.568-17.5a434.506,434.506,0,0,1,50.407-5.8c17.014-.957,36.331-1.792,47.608-12.961,7.167-7.1,9.252-16.9,9.539-26.158.935-30.365-13.574-63.224,5.049-89.523,7.808-11.029,20.558-19.085,28.308-30.147,11.219-16.028,10.252-36.385,2.655-53.467S430.6,45.905,417.333,31.672c-4.408-4.709-9.087-9.6-15.681-11.786-6.855-2.272-14.627-1.229-21.977-.154-33.425,4.881-68.13,10.195-96.166,26.957-13.925,8.324-25.556,19.121-37.983,29.05-26.825,21.457-57.917,41.273-93.35,49.744C123.388,132.364,94.105,150.926,96.71,179.657Z",
    transform: "translate(-96.51 -13.833)",
    fill: "#00a8ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9901",
    "data-name": "Caminho 9901",
    d: "M393.648,340.708a5.525,5.525,0,0,1,.523-.237s-14.774-8.324-18.888-10.635a34.682,34.682,0,0,1-4.243-2.985c5.138-1.863,12.327-5.192,16.125-10.191,0,0-1.075-.9-2.455-2.2l1.483-1.734s7.747-6.242,2.422-9.478c-4.329-2.63-7.059,4.354-7.93,7.066l-.3-.358s-8.335,12.732-19.576,6.4a15.411,15.411,0,0,1-1.734-3.164,14.307,14.307,0,0,0-3.942-5.526l-1.143-4.418-2.039-1.681a76.2,76.2,0,0,1,.358-7.883q.025-.244.054-.484a10.424,10.424,0,0,0,6.722-9.611,9.968,9.968,0,0,0-1.018-4.393c1.595-1.824,2.752-4.3,2.408-6.45-.269-1.666-1.691-2.752-3.4-3.519a27.614,27.614,0,0,0-5.149-1.727,14.231,14.231,0,0,0-8.467-.133,29.185,29.185,0,0,0-10.642,6.561c-2.731,2.462-5.733,6.747-8.958,8.6s-6.382,4.253-7.633,7.618c-1.763,4.759.652,9.872,1.742,14.81A28.459,28.459,0,0,1,316.6,321.6c-2.114,5.285-5.895,10.449-4.966,16.035.717,4.243,4.074,7.525,8.206,9.421a20.713,20.713,0,0,0,5.809,1.863,19.508,19.508,0,0,0,10.41-.928,38.6,38.6,0,0,1-5.809,10.75c-2.383,3.031-2.15,4.68-.043,4.838q-.111.426-.208.907c-.684,3.358-.9,8.851.251,17.838,2.906,22.658-3.39,29.591-3.39,29.591s.674.237,1.892.588q-.075.2-.15.419c-1.333,3.784-2.594,10.449-.043,19.35,2.748,9.568,3.555,13.975,3.788,15.867v.111a4.051,4.051,0,0,0-2.018,2.071,5.884,5.884,0,0,0,.882,6.45v8.779h1.211v-7.4a20.894,20.894,0,0,1,2.713,4.124,9.356,9.356,0,0,0,7.217,5.11c3.118.423,6.558.577,7.991-.452,0,0,1.075-2.025-4.067-4.479l-.043-.064c-1.691-2.465-4.3-6.744-4.694-10.1a28.068,28.068,0,0,0-1.326-6.052h0a17.782,17.782,0,0,1-.946-4.569c-.358-4.762-.982-15.2-.057-17.5.624-1.552.993-5.447,1.2-8.851,0-.154.018-.308.029-.459a67.676,67.676,0,0,0,16.207.118v2.258s-2.179,6.937,2.179,16.878c0,0,5.909,9.026,7.246,14.359q.057.229.1.448c-.792.093-4.282.914-2.989,8.31l-.244,9.711h1.211l.244-8.553s1.211-2.082,5.329,2.311q.935,1,1.691,1.853a15.025,15.025,0,0,0,11.761,4.959c2.645-.093,5.171-.358,6.16-1.032,0,0,2.422-1.849-3.634-2.774l-2.788-.828h-.1l-.4-.444c-2.114-2.394-5.185-6.45-5.97-10.571a19,19,0,0,0-1.311-4.128l-2.265-5.1-5.328-27.255s.28-1.2.552-2.663c.029-.161.061-.33.09-.494l.81-.312s4.845-3.469-2.422-24.506c0,0-2.824-11.718-4.253-21.052l3.526-.677s-.545-8.242-1.63-13.975c.717-2.687,1.111-5.017.663-6.156a10.725,10.725,0,0,1-.616-3.225,73.849,73.849,0,0,0-.8-7.421l4.562,3.225,23.005,11.108a6.914,6.914,0,0,1-.767-4.5c1.677,2.4,6.128,7.747,9.969,3.343C404.143,343.614,396.654,341.392,393.648,340.708Z",
    transform: "translate(-234.43 -173.124)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9902",
    "data-name": "Caminho 9902",
    d: "M526.728,473.3s11.857,2.053,7.3,7.525-10.033-4.332-10.033-4.332Z",
    transform: "translate(-370.785 -305.641)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9903",
    "data-name": "Caminho 9903",
    d: "M421.54,374.67s5.927,2.738,7.98,8.435,11.4,14.136,15.276,16.419,17.784,10.488,17.784,10.488-5.927,2.279-2.963,8.664l-21.661-10.943-9.8-7.3Z",
    transform: "translate(-305.046 -242.354)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9904",
    "data-name": "Caminho 9904",
    d: "M421.54,374.67s5.927,2.738,7.98,8.435,11.4,14.136,15.276,16.419,17.784,10.488,17.784,10.488-5.927,2.279-2.963,8.664l-21.661-10.943-9.8-7.3Z",
    transform: "translate(-305.046 -242.354)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9905",
    "data-name": "Caminho 9905",
    d: "M499.707,6.32S473.591-3.219,445.82,40.437c0,0-11.674,24.367-37.761,24.27l-2.8-6.371L400,60.4l70.592,161.25,5.325-1.709-33.246-76.375c11.029-.846,35.608-8.786,58.025-58.283,0,0,20.138-37.589,49.629-33.146Z",
    transform: "translate(-291.225 -5.43)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9906",
    "data-name": "Caminho 9906",
    d: "M410.51,69.832l34.217,77.379s33.182,8.1,62.565-56.774c0,0,19.708-36.769,48.547-32.422l-49.5-44.824S480.79,3.873,453.628,46.565C453.625,46.565,440.374,74.246,410.51,69.832Z",
    transform: "translate(-297.969 -9.852)",
    fill: "#5d76b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9907",
    "data-name": "Caminho 9907",
    d: "M432.867,141.478l1.663,4.637-3.2,3.178,3.73-.459,1.394,4.243,1.1-4.816,3.472-.28-3.078-2.5.713-4.544-2.72,3.039Z",
    transform: "translate(-276.745 -90.431)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9908",
    "data-name": "Caminho 9908",
    d: "M452.739,102.172l1.48,4.375-2.8,3.479,3.329-.763,1.784,3.974.444-4.934,3.641-.591-3.157-2.057.674-4.325-2.24,2.9Z",
    transform: "translate(-289.636 -65.015)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9909",
    "data-name": "Caminho 9909",
    d: "M482.477,76.824l1.6,3.712-2.748,3.831,3.282-1.111,1.6,3.712,1.064-4.594,3.773-.681-3.512-2.01,1.2-4.683-2.931,3.569Z",
    transform: "translate(-308.829 -48.12)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9910",
    "data-name": "Caminho 9910",
    d: "M514.327,76.442l1.605,3.712L512.6,83.426l3.813-.9,1.473,3.8,1.2-4.683,3.863-.548-3.15-1.487,1.1-4.816-3.239,3.4Z",
    transform: "translate(-328.893 -47.985)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9911",
    "data-name": "Caminho 9911",
    d: "M541.677,95.742l1.6,3.712-3.329,3.272,3.813-.9,1.473,3.8,1.193-4.683,3.863-.548-3.15-1.487,1.107-4.816-3.243,3.4Z",
    transform: "translate(-346.443 -60.369)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9912",
    "data-name": "Caminho 9912",
    d: "M556.307,125.452l1.6,3.712-3.329,3.272,3.809-.9,1.476,3.8,1.193-4.683,3.863-.548-3.15-1.487,1.107-4.816-3.243,3.4Z",
    transform: "translate(-355.831 -79.433)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9913",
    "data-name": "Caminho 9913",
    d: "M549.867,171.684l1.784,3.974-3.171,4.895,3.841-1.695,1.645,3.49.8-4.984,4.063-1.656-3.591-1.566.752-4.762-2.447,3.429Z",
    transform: "translate(-351.916 -108.68)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9914",
    "data-name": "Caminho 9914",
    d: "M533.807,215.856,535.2,220.1l-2.781,4.622,3.712-1.6,1.562,3.934.745-5.339,3.49-1.641-3.15-1.487.835-5.207L537,217.121Z",
    transform: "translate(-341.611 -136.913)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9915",
    "data-name": "Caminho 9915",
    d: "M502.131,244.143l1.44,4.594L500.21,252.8l3.329-.763,1.476,3.805,1.1-4.816,3.451-1.423-2.716-1.978.745-5.336-2.53,3.87Z",
    transform: "translate(-320.943 -155.464)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9916",
    "data-name": "Caminho 9916",
    d: "M469.9,250.9l1.311,4.683L467.7,258.6l3.562-.15,1.032,3.723,1.376-4.425,3.9-.77-2.856-2.458.674-4.325-2.548,2.73Z",
    transform: "translate(-300.083 -160.533)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9917",
    "data-name": "Caminho 9917",
    d: "M439.783,226.542l1.355,4.465-4.307,2.978,4.537.143.871,4.6,1.716-5.045,4.264-.251-3.207-2.408,1.354-5.569-3.813,3.411Z",
    transform: "translate(-280.274 -144.665)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9918",
    "data-name": "Caminho 9918",
    d: "M428.493,183.762l1.355,4.465L425.54,191.2l4.536.14.871,4.608,1.716-5.049,4.264-.247-3.211-2.408,1.358-5.569-3.813,3.408Z",
    transform: "translate(-273.03 -117.214)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9919",
    "data-name": "Caminho 9919",
    d: "M593.441,159.638l-7.883-8.768a1.372,1.372,0,0,0-1.939-.1l-.634.581-3.3-3.673a3.494,3.494,0,0,0-4.934-.265l-4.3,3.859a3.494,3.494,0,0,0-.265,4.934l3.3,3.673-.641.577a1.372,1.372,0,0,0-.1,1.939l7.883,8.768a1.372,1.372,0,0,0,1.939.1l10.779-9.675a1.372,1.372,0,0,0,.1-1.949ZM571.722,156a3.494,3.494,0,0,1,.265-4.934l2.419-2.171a3.494,3.494,0,0,1,4.934.265l2.705,3.014-7.618,6.837Zm12.212,4.966,1.276,1.433a.769.769,0,0,1-1.143,1.028l-1.347-1.5a1.863,1.863,0,1,1,1.215-.95Z",
    transform: "translate(-399.855 -95.953)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9920",
    "data-name": "Caminho 9920",
    d: "M576.03,148.927l-4.081,3.666a3.318,3.318,0,0,0-.251,4.687l3.458,3.852.892-.8-2.9-3.225a3.318,3.318,0,0,1,.251-4.687l2.3-2.06a3.318,3.318,0,0,1,4.687.251l2.9,3.225.892-.8-3.458-3.852A3.318,3.318,0,0,0,576.03,148.927Z",
    transform: "translate(-400.851 -96.956)",
    fill: "#f0f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9921",
    "data-name": "Caminho 9921",
    d: "M589.711,158.76l-10.238,9.184a1.3,1.3,0,0,0-.1,1.842l7.479,8.328a1.3,1.3,0,0,0,1.842.1l10.241-9.195a1.3,1.3,0,0,0,.1-1.842l-7.468-8.317a1.3,1.3,0,0,0-1.856-.1Zm.29,9.693,1.211,1.351a.726.726,0,1,1-1.075.975l-1.279-1.433a1.77,1.77,0,1,1,1.154-.9Z",
    transform: "translate(-406.109 -103.593)",
    fill: "#f0f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9922",
    "data-name": "Caminho 9922",
    d: "M309.21,153.325l68.8,157.147,5.207-1.673L314.37,151.3Z",
    transform: "translate(-198.385 -97.079)",
    fill: "#f0f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9923",
    "data-name": "Caminho 9923",
    d: "M499.81,377.8s2.738-11.173,7.754-7.98-2.279,9.349-2.279,9.349l-2.053,2.508Z",
    transform: "translate(-355.269 -238.875)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9924",
    "data-name": "Caminho 9924",
    d: "M326.684,359.16l2.6,2.243,1.1,4.45-1.781-1.032V361.4l-1.917-.229Z",
    transform: "translate(-209.595 -230.456)",
    fill: "#dedff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9925",
    "data-name": "Caminho 9925",
    d: "M326.684,359.16l2.6,2.243,1.1,4.45-1.781-1.032V361.4l-1.917-.229Z",
    transform: "translate(-209.595 -230.456)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9926",
    "data-name": "Caminho 9926",
    d: "M444.77,488.3l1.516,19.612,4.533-.914s-1.007-15.96-3.021-18.7S444.77,488.3,444.77,488.3Z",
    transform: "translate(-319.952 -314.486)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9927",
    "data-name": "Caminho 9927",
    d: "M444.77,488.3l1.516,19.612,4.533-.914s-1.007-15.96-3.021-18.7S444.77,488.3,444.77,488.3Z",
    transform: "translate(-319.952 -314.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9928",
    "data-name": "Caminho 9928",
    d: "M379.13,717.193l-7.3,1.139-4.1-3.193-2.963-9.349v-3.426a7.545,7.545,0,0,0-.082-1.225c-.219-1.853-.978-6.21-3.583-15.649-2.4-8.768-1.215-15.34.039-19.07a16.882,16.882,0,0,1,1.555-3.5h9.8s-.054,2.72-.237,5.862c-.2,3.358-.541,7.2-1.132,8.733-.874,2.272-.276,12.567.054,17.264a18.282,18.282,0,0,0,.892,4.5h0a28.8,28.8,0,0,1,1.251,5.97c.358,3.315,2.827,7.525,4.418,9.965C378.557,716.427,379.13,717.193,379.13,717.193Z",
    transform: "translate(-265.374 -427.314)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9929",
    "data-name": "Caminho 9929",
    d: "M462.775,714.016l-3.193.914-6.156-2.508-7.754-8.206v-4.558a8.716,8.716,0,0,0-.247-1.569c-1.258-5.26-6.808-14.161-6.808-14.161-4.1-9.8-2.053-16.645-2.053-16.645v-7.073s10.718-3.648,11.173-2.279c.254.767-.065,3.049-.391,4.9-.258,1.433-.519,2.623-.519,2.623l5.017,26.907,2.132,5.017a19.339,19.339,0,0,1,1.233,4.071c.742,4.053,3.633,8.063,5.622,10.424A28.007,28.007,0,0,0,462.775,714.016Z",
    transform: "translate(-314.358 -423.915)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9930",
    "data-name": "Caminho 9930",
    d: "M388.034,785.377l-7.3,1.139-4.1-3.193-2.963-9.349v-3.426a7.548,7.548,0,0,0-.082-1.226,1.7,1.7,0,0,1,.312-.143s.914,3.422.455,5.017c-.358,1.272,2.748,6.024,4.028,7.883a5.4,5.4,0,0,0,2.627,2.086,7.025,7.025,0,0,0,5.662-.767C387.461,784.61,388.034,785.377,388.034,785.377Z",
    transform: "translate(-274.278 -495.497)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9931",
    "data-name": "Caminho 9931",
    d: "M382.336,783.866s-2.888,2.014-5.93.935a5.4,5.4,0,0,1-2.627-2.071c-1.279-1.874-4.393-6.626-4.028-7.883.455-1.595-.455-5.017-.455-5.017a3.75,3.75,0,0,0-1.971,2.071,6.024,6.024,0,0,0,.831,6.371v8.657H369.3v-7.288a20.723,20.723,0,0,1,2.555,4.067,8.84,8.84,0,0,0,6.808,5.038c2.935.416,6.174.57,7.525-.444C386.167,788.3,387.17,786.306,382.336,783.866Z",
    transform: "translate(-269.902 -495.914)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9932",
    "data-name": "Caminho 9932",
    d: "M479.561,786.433l-3.193.914-6.156-2.508-7.754-8.206v-4.558a8.7,8.7,0,0,0-.247-1.569,1.7,1.7,0,0,1,.247-.025c0,1.186,2.021,4.01,3.44,5.841a35.743,35.743,0,0,1,2.068,2.992A11,11,0,0,0,477.6,784.3C478.726,785.63,479.561,786.433,479.561,786.433Z",
    transform: "translate(-331.143 -496.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9933",
    "data-name": "Caminho 9933",
    d: "M457.115,771.74s-4.332,0-2.963,8.209l-.226,9.578h1.139l.229-8.435s1.139-2.053,5.017,2.279q.881.986,1.594,1.828a13.85,13.85,0,0,0,11.076,4.891c2.487-.093,4.87-.358,5.8-1.018,0,0,2.279-1.824-3.422-2.738l-2.623-.8s-6.59.717-10.112-4.963a35.457,35.457,0,0,0-2.071-3.006C459.139,775.75,457.115,772.926,457.115,771.74Z",
    transform: "translate(-325.8 -497.14)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9934",
    "data-name": "Caminho 9934",
    d: "M365.331,662.93h9.8s-.054,2.72-.237,5.862a69.249,69.249,0,0,1-11.108-2.361A16.88,16.88,0,0,1,365.331,662.93Z",
    transform: "translate(-267.99 -427.32)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9935",
    "data-name": "Caminho 9935",
    d: "M448.222,662.828a45.4,45.4,0,0,1-10.782,2.68v-5.3s10.718-3.648,11.173-2.279C448.871,658.7,448.552,660.983,448.222,662.828Z",
    transform: "translate(-315.249 -423.915)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9936",
    "data-name": "Caminho 9936",
    d: "M398.855,571.12c-18.7,7.754-39.675,0-39.675,0s5.927-6.841,3.193-29.186c-1.075-8.862-.881-14.28-.236-17.594.978-5.042,2.971-5.207,2.971-5.207l26.907-3.193a15.539,15.539,0,0,0-.122,4.372c.641,9.08,4.68,26.639,4.68,26.639C403.416,567.7,398.855,571.12,398.855,571.12Z",
    transform: "translate(-265.032 -333.002)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9937",
    "data-name": "Caminho 9937",
    d: "M404.907,324.695c-.7,1.043-1.115,3.171-1.365,5.622a106.684,106.684,0,0,0-.233,12.846s-13.911,7.525-10.718-2.279A24.5,24.5,0,0,0,391,322.645S407.19,321.276,404.907,324.695Z",
    transform: "translate(-285.45 -208.797)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9938",
    "data-name": "Caminho 9938",
    d: "M404.907,324.7c-.7,1.043-1.114,3.171-1.365,5.622a10.262,10.262,0,0,1-10.392-1.577,23.325,23.325,0,0,0-2.15-6.092S407.19,321.28,404.907,324.7Z",
    transform: "translate(-285.45 -208.801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1914",
    "data-name": "Elipse 1914",
    cx: 10.263,
    cy: 10.263,
    r: 10.263,
    transform: "translate(103.949 101.303)",
    fill: "#f8bdc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9939",
    "data-name": "Caminho 9939",
    d: "M397.192,520.312c-1.251,3.433-2.387,6.117-2.387,6.117s-10.718-9.123-18.924-4.787c-3.874,2.042-6.83,2.92-8.442,2.7.978-5.042,2.971-5.207,2.971-5.207l26.907-3.193A15.363,15.363,0,0,0,397.192,520.312Z",
    transform: "translate(-270.332 -333.002)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9940",
    "data-name": "Caminho 9940",
    d: "M392.342,422.206s-10.718-9.12-18.924-4.787-12.312,3.422-8.209-2.053,9.578-17.1,5.472-25.768-5.7-22.346-2.508-25.994,6.156-7.754,6.156-8.665c0,0,11.628,8.435,13.911,11.857a45.176,45.176,0,0,1,2.917,6.568c.641,1.663,1.322,3.49,1.992,5.332a67.8,67.8,0,0,1,2.544,8.851,74.815,74.815,0,0,1,1.544,11.646,11.027,11.027,0,0,0,.581,3.175C399.183,406.017,392.342,422.206,392.342,422.206Z",
    transform: "translate(-267.868 -229.693)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9941",
    "data-name": "Caminho 9941",
    d: "M406.387,360.461l-.269,4.759-13.165-10.033s-.251-2.014,3.171.036S406.387,360.461,406.387,360.461Z",
    transform: "translate(-286.7 -229.284)",
    fill: "#dedff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9942",
    "data-name": "Caminho 9942",
    d: "M405.557,403.849c-12.044.222-25.693-13.226-25.693-13.226-4.787-12.767,11.4-10.033,11.4-10.033s1.333,3.433,9.757,9.077c.641,1.663,1.322,3.49,1.992,5.332A67.794,67.794,0,0,1,405.557,403.849Z",
    transform: "translate(-277.737 -245.994)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9943",
    "data-name": "Caminho 9943",
    d: "M379.865,386.172s15.505,15.276,28.047,13c0,0,14.821-3.648,20.751-11.857a61.124,61.124,0,0,1-6.385-6.611s-7.98,12.767-18.7,6.156-12.312-10.718-12.312-10.718S375.077,373.4,379.865,386.172Z",
    transform: "translate(-277.737 -243.138)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9944",
    "data-name": "Caminho 9944",
    d: "M358.139,271.861a12.937,12.937,0,0,0-7.973-.133,27.452,27.452,0,0,0-10.033,6.472c-2.573,2.426-5.4,6.654-8.432,8.474s-5.988,4.193-7.167,7.525c-1.659,4.694.613,9.736,1.641,14.606a29.314,29.314,0,0,1-1.29,16.408c-1.992,5.21-5.551,10.306-4.658,15.817.935,5.895,6.851,9.894,12.732,10.9,4.006.688,8.342.265,11.746-1.949a7.167,7.167,0,0,0,2.365-2.329c1.451-2.508.5-5.665-.4-8.425-1.835-5.651-3.282-11.42-4.734-17.182-.846-3.365-1.684-6.973-.487-10.23,1.168-3.178,4.081-5.4,7.127-6.887a10.679,10.679,0,0,0,3.361-2.078,5.781,5.781,0,0,0,1.122-1.9c1.534-4.089-.186-9.363,2.773-12.577,1.505-1.634,3.823-2.2,5.68-3.422,2.344-1.544,4.658-5.192,4.218-8.152C365.252,273.678,360.83,272.625,358.139,271.861Z",
    transform: "translate(-239.947 -175.93)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9945",
    "data-name": "Caminho 9945",
    d: "M356.859,271.221a12.936,12.936,0,0,0-7.973-.133,27.451,27.451,0,0,0-10.033,6.471c-2.573,2.426-5.4,6.654-8.432,8.475s-5.988,4.192-7.167,7.525c-1.659,4.694.613,9.736,1.641,14.606a29.315,29.315,0,0,1-1.29,16.408c-1.992,5.21-5.551,10.306-4.658,15.817.935,5.895,6.851,9.894,12.732,10.9,4.006.688,8.342.265,11.746-1.949a7.167,7.167,0,0,0,2.365-2.329c1.451-2.508.5-5.665-.4-8.424-1.835-5.651-3.282-11.42-4.734-17.182-.846-3.365-1.684-6.973-.487-10.23,1.168-3.178,4.081-5.4,7.127-6.887a10.677,10.677,0,0,0,3.361-2.078,5.779,5.779,0,0,0,1.122-1.9c1.534-4.089-.186-9.363,2.773-12.577,1.5-1.634,3.823-2.2,5.68-3.422,2.344-1.544,4.658-5.192,4.218-8.152C363.976,273.042,359.554,271.984,356.859,271.221Z",
    transform: "translate(-239.126 -175.519)",
    fill: "#eb6475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9946",
    "data-name": "Caminho 9946",
    d: "M205.841,594.162s-4.751-16.125.892-28a25.474,25.474,0,0,0,2.06-15.982,42.845,42.845,0,0,0-2.261-7.5",
    transform: "translate(-165.439 -350.16)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9947",
    "data-name": "Caminho 9947",
    d: "M208.067,515.323c0,1.978-3.583,7.708-3.583,7.708s-3.583-5.733-3.583-7.708a3.583,3.583,0,1,1,7.167,0Z",
    transform: "translate(-163.469 -330.307)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9948",
    "data-name": "Caminho 9948",
    d: "M224.525,542.634c-1.075,1.659-7.2,4.526-7.2,4.526s.111-6.758,1.186-8.417a3.583,3.583,0,0,1,6.009,3.892Z",
    transform: "translate(-174.012 -346.67)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9949",
    "data-name": "Caminho 9949",
    d: "M221.476,592.5c-1.767.889-8.5.276-8.5.276s3.508-5.776,5.271-6.665a3.583,3.583,0,0,1,3.225,6.393Z",
    transform: "translate(-171.22 -377.823)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9950",
    "data-name": "Caminho 9950",
    d: "M212.338,632.516c-1.591,1.175-8.328,1.706-8.328,1.706s2.48-6.285,4.071-7.46a3.583,3.583,0,0,1,4.257,5.755Z",
    transform: "translate(-165.465 -403.725)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9951",
    "data-name": "Caminho 9951",
    d: "M194.17,554.747c1.433,1.376,8.023,2.806,8.023,2.806s-1.616-6.561-3.035-7.937a3.583,3.583,0,1,0-4.988,5.131Z",
    transform: "translate(-158.363 -353.87)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9952",
    "data-name": "Caminho 9952",
    d: "M182.136,599.932c1.767.889,8.5.276,8.5.276s-3.508-5.776-5.271-6.665a3.583,3.583,0,1,0-3.225,6.393Z",
    transform: "translate(-150.076 -382.505)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9953",
    "data-name": "Caminho 9953",
    d: "M179.545,647.106c1.591,1.175,8.328,1.706,8.328,1.706s-2.48-6.285-4.071-7.461a3.583,3.583,0,0,0-4.257,5.755Z",
    transform: "translate(-148.922 -413.087)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9954",
    "data-name": "Caminho 9954",
    d: "M553.787,802.856a4.182,4.182,0,0,0,1.372-2.071,1.839,1.839,0,0,0-.96-2.111c-.882-.337-1.824.272-2.537.892a3.375,3.375,0,0,1-2.469,1.19,3.756,3.756,0,0,0,1.161-3.515,1.471,1.471,0,0,0-.323-.717c-.491-.523-1.376-.3-1.964.115-1.863,1.311-2.383,3.841-2.394,6.12a11.734,11.734,0,0,1-.036-2.508,2.589,2.589,0,0,0-.946-2.229,2.865,2.865,0,0,0-1.433-.34,2.984,2.984,0,0,0-2.344.666,2.305,2.305,0,0,0,.093,2.867,9.321,9.321,0,0,0,2.426,1.942,5.377,5.377,0,0,1,1.734,1.652,1.637,1.637,0,0,1,.129.294h5.25A14.63,14.63,0,0,0,553.787,802.856Z",
    transform: "translate(-381.351 -512.848)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9955",
    "data-name": "Caminho 9955",
    d: "M736.708,433.87a35.8,35.8,0,0,0-6.529,37.238c8.464,22.245-14.509,59.24-14.509,59.24s.247-.036.717-.115c30.792-5.436,46.089-40.65,28.968-66.811C738.976,453.693,733.752,442.284,736.708,433.87Z",
    transform: "translate(-493.779 -280.34)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9956",
    "data-name": "Caminho 9956",
    d: "M736.708,434.56a35.8,35.8,0,0,0-6.529,37.238c8.464,22.245-14.509,59.24-14.509,59.24s.247-.036.717-.115c30.777-5.436,46.075-40.664,28.953-66.822C738.976,454.387,733.751,442.959,736.708,434.56Z",
    transform: "translate(-493.779 -280.783)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9957",
    "data-name": "Caminho 9957",
    d: "M736.708,433.87s-8.464,18.375,0,33.368,1.433,57.065-21.038,63.11",
    transform: "translate(-493.779 -280.34)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9958",
    "data-name": "Caminho 9958",
    d: "M756.561,602.745s-17.107-2.723-18.666,12.606S705,632.816,705,632.816l.588.391c25.872,16.985,50.607,10.818,46.877-11.736C751.082,613.083,751.193,604.662,756.561,602.745Z",
    transform: "translate(-486.933 -388.581)",
    fill: "#00a8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9959",
    "data-name": "Caminho 9959",
    d: "M756.561,603.08s-13.28,2.913-12.183,14.989S724.655,644.618,705,633.151",
    transform: "translate(-486.933 -388.916)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9960",
    "data-name": "Caminho 9960",
    d: "M712.157,664.858s-13.473-2.7-17.067-6.285-19.762-9.879-21.557-5.375-24.252,19.744-8.994,22.439,35.93,3.583,40.42,1.792S712.157,664.858,712.157,664.858Z",
    transform: "translate(-457.579 -420.072)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9961",
    "data-name": "Caminho 9961",
    d: "M664.533,697.509c15.272,2.695,35.93,3.583,40.42,1.792,3.422-1.369,5.8-7.941,6.737-11l.448.093s-2.695,10.779-7.185,12.574-25.151.9-40.42-1.792c-4.407-.777-5.669-2.6-5.192-4.916C659.727,695.757,661.265,696.918,664.533,697.509Z",
    transform: "translate(-457.574 -443.599)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9962",
    "data-name": "Caminho 9962",
    d: "M179.36,676.03s8.03-.247,10.449-1.971,12.352-3.781,12.95-1.018,12.065,13.746,2.988,13.81-21.063-1.412-23.478-2.867S179.36,676.03,179.36,676.03Z",
    transform: "translate(-149.647 -432.941)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9963",
    "data-name": "Caminho 9963",
    d: "M205.913,693.682c-9.066.071-21.063-1.412-23.478-2.867-1.838-1.122-2.573-5.139-2.817-6.995h-.269s.509,6.475,2.924,7.948,14.412,2.956,23.478,2.867c2.616-.021,3.519-.953,3.472-2.329C208.859,693.144,207.863,693.663,205.913,693.682Z",
    transform: "translate(-149.641 -440.724)",
    opacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookieimg);
export default __webpack_public_path__ + "static/media/cookieimg.4679c2fe45b66eb1034c8ac162192a66.svg";
export { ForwardRef as ReactComponent };